<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="mchName">
        <el-input v-model="queryParams.mchName" filterable placeholder="商户名称" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="mchId">
        <el-input v-model="queryParams.mchId" filterable placeholder="商户ID" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="dateRange">
        <el-date-picker
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                v-model="dateRange"
                @change="search"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        <el-button type="primary" size="medium" icon="el-icon-plus" @click.native="add">新增</el-button>
      </el-form-item>
    </el-form>
    <!--搜索-->
    <!--列表-->
    <el-table :data="tableData" row-key="id" border v-loading="loading">
      <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="mchName" label="商户名称" min-width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="mchId" label="商户ID" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="appId" label="APPID" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="currentPay" label="当前收款" align="center" min-width="80">
          <template slot-scope="{row}">
            <el-switch
              :disabled="row.currentPay == 1"
              v-model="row.currentPay"
              active-color="#13ce66"
              inactive-color="#C0CCDA"
              active-value="1"
              inactive-value="0"
              @change="handlePayChange(row)">
            </el-switch>
          </template>
      </el-table-column>
      <el-table-column prop="shortName" label="商户简称" align="center" min-width="120" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="maxMoney" label="日最大限额" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="money" label="日收总额" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="actualMoney" label="实收总额" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="priority" label="优先级" align="center" min-width="80" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="status" label="是否轮询" align="center" min-width="80">
          <template slot="header">
              <el-tooltip content="是否参与账号轮询收款" placement="top">
                  <i class="el-icon-question"></i>
              </el-tooltip>
              是否轮询
          </template>
          <template slot-scope="{row}">
            <el-switch
              v-model="row.status"
              active-color="#13ce66"
              inactive-color="#C0CCDA"
              active-value="1"
              inactive-value="0"
              @change="handleStatusChange(row)">
            </el-switch>
          </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.createTime,'{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="修改时间" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.updateTime,'{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <!--操作-->
      <el-table-column label="操作" min-width="80" align="center" fixed="right">
        <template slot-scope="scope">
            <el-button size="mini" type="primary" plain icon="el-icon-edit" @click="updateRow(scope.row)" >编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <pagination
        v-show="total>0"
        :total="total"
        :page.sync="page"
        :limit.sync="pageSize"
        @pagination="initData"
    />
    <!-- 表单 -->
    <el-dialog :title="title" :visible.sync="dialog" @close="dialogClose" :lock-scroll="false" width="600px" append-to-body v-dialogDrag :close-on-click-modal="false">
      <el-form :model="form" label-width="80px" ref="form" :rules="rules">
        <el-form-item label="商户名称:" prop="mchName" label-width="100px">
          <el-input v-model="form.mchName" autocomplete="off" style="width: 85%" placeholder="请输入商户名称"></el-input>
        </el-form-item>
        <el-form-item label="APPID:" prop="appId" label-width="100px">
          <el-input v-model="form.appId" autocomplete="off" style="width: 85%" placeholder="请输入APPID"></el-input>
        </el-form-item>
        <el-form-item label="商户ID:" prop="mchId" label-width="100px">
          <el-input v-model="form.mchId" autocomplete="off" style="width: 85%" placeholder="请输入商户ID"></el-input>
        </el-form-item>
        <el-form-item label="商户简称:" prop="shortName" label-width="100px">
          <el-input v-model="form.shortName" autocomplete="off" style="width: 85%" placeholder="请输入商户简称"></el-input>
        </el-form-item>
        <el-form-item label="日最大限额:" prop="maxMoney" label-width="100px">
          <el-input v-model="form.maxMoney" autocomplete="off" style="width: 85%" placeholder="请输入日最大限额"></el-input>
        </el-form-item>
        <el-form-item label="优先级:" prop="priority" label-width="100px">
          <template>
            <el-input-number v-model="form.priority" controls-position="right" :min="1" :max="10"></el-input-number>
          </template>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary" @click="cancelDialog()">取消</el-button>
        <el-button type="success" @click="submitForm()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { alipayRelationList,submitAlipayRelation,alipayRelationDetail,changeAlipayStatus,switchAliPay } from "@/api/api.js";

  export default {
    name: 'alipay',
    data () {
      return {
        loading: false,
        dateRange: [],
        queryParams: {
          mchName: undefined,
          mchId: undefined
        },
        tableData: [{
          id: undefined,
          mchName: undefined,
          mchId: undefined,
          appId: undefined,
          shortName: undefined,
          maxMoney: undefined,
          money: undefined,
          actualMoney: undefined,
          priority: undefined,
          createTime: undefined,
          updateTime: undefined,
          status: undefined
        }],
        searchTime: [],
        page: 1,
        pageSize: 20,
        total: 0,
        //表单
        title:"",
        method:'add',
        dialog:false,
        form:{},
        rules:{
          mchName:[
            { required: true, message: "请输入商户名称", trigger: "blur" }
          ],
          mchId:[
            { required: true, message: "请输入商户ID", trigger: "blur" }
          ],
          maxMoney:[
            { required: true, message: "请输入日最大限额", trigger: "blur" }
          ],
          priority:[
            { required: true, message: "请输入优先级", trigger: "blur" }
          ]
        },
      }
    },
    computed: {
      adminShow () {
        return this.$store.getters.user.userType == "1";
      }
    },
    methods: {
      // 搜索
      search () {
        this.page = 1;
        this.initData();
      },
      // 重置
      resetQuery () {
        this.dateRange = [];
        this.resetForm("queryForm");
        this.search();
      },
      // 获取列表的数据
      initData () {
        let params = {
          model: {
            ... this.addDateRange(this.queryParams, this.dateRange),
            order: this.sortOrder,
            sort: this.sortName,
          },
          page: this.page,
          pageSize: this.pageSize,
        };
        this.loading = true;
        this.tableData = [];
        alipayRelationList(params).then(res => {
          this.loading = false;
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        })
      },
      // 弹窗
      dialogClose(){
        this.$refs.form.clearValidate();
        this.dialog = false;
      },
      // 弹窗的取消
      cancelDialog(){
        this.dialog = false;
      },
      //提交表单
      submitForm(){
        this.$refs.form.validate(valid=>{
          if (valid) {
            let params ={
              ...this.form
            }
            submitAlipayRelation(params).then(res=>{
              this.$notify({
                title: '成功',
                message: '支付宝商户配置成功',
                type: 'success'
              });
              this.dialog = false;
              this.initData();
            })
          }
        });
      },
      // 编辑
      updateRow(row){
        this.dialog = true;
        this.title = "编辑支付宝商户配置";
        alipayRelationDetail({id: row.id}).then(res=>{
          this.form = res.data.data;
        })
      },
      add(){
        this.title = "新增支付宝商户配置";
        this.dialog = true;
        this.form = {};
      },
      handleStatusChange(row){
        let params = {appId: row.appId, status: row.status}
        changeAlipayStatus(params).then(res=>{
          this.$notify({
            title: '成功',
            message: row.status == 0 ? '账号不参与轮询收款' : '账号参与轮询收款',
            type: 'success'
          });
          this.initData();
        }).catch(error => {
          this.$notify({
            title: '错误',
            message: '状态切换失败，请重试',
            type: 'error'
          });
          row.status = row.status === '1' ? '0' : '1';
        })
      },
      handlePayChange(row){
        let appId = row.appId
        switchAliPay({appId}).then(res=>{
          this.$notify({
            title: '成功',
            message: '切换收款账号成功',
            type: 'success'
          });
          this.initData();
        }).catch(error => {
          this.$notify({
            title: '错误',
            message: '收款账切换失败，请重试',
            type: 'error'
          });
          row.currentPay =  '0';
        })
      },
    },
    mounted () {
      this.initData();
    },
  };
</script>
<style scoped lang="less">
.table-expand{
  margin-left: 10px;
  .el-form-item {
    margin-bottom: 0px;
  }
}

</style>
